// extracted by mini-css-extract-plugin
var _1 = "ChatroomDateDivider-modulechatroomDateDivider__FvKaK";
var _2 = "ChatroomDateDivider-modulelabel__bV06K";
export { _1 as "chatroomDateDivider", _2 as "label" }
